// QL-414 — the "Advisor notes" group of an Insert Field menu: one entry per
// flow page that takes advisor notes. A note written on a goal page belongs to
// one goal, so those entries are only offered where a section prints per goal
// or per portfolio; in a global section they would be empty.

export const T = {
  en_GB: { advisorNotes: "Advisor notes", advisorNote: (page: string) => `Advisor note – ${page}` },
  nb_NO: {
    advisorNotes: "Rådgivernotater",
    advisorNote: (page: string) => `Rådgivernotat – ${page}`,
  },
} as const;
